import services from "./services";

export const security = async ({ from, to, next, router, store }) => {
    try {
        const user = await services.checkToken();

        if (!user || !user.id) {
            throw new Error('Não foi possível validar o token!');
        }

        store.commit('sample/SET_USER', user);

        next();
    } catch (err) {
        next({ name: 'sample_login' });
    }
}

export default {
    security,
}
